// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-tab{
    display: flex;
    padding: 20px 20px 0px 20px;
    align-items: start;
    background-color: white !important;
    /* border-bottom: 1px solid gray ; */
    box-shadow: 0px 0px 5px #d2d2e4;
    margin-bottom: 20px;
    
}

.contribution-first-table{
 background-color: white !important;
 margin-top: -20px;
 padding-top:20px ;
 /* margin-top: 10px !important; */
}



.header-tab>div:nth-child(2){
    width: 80%;
    margin-left: 30px;
    height: 46px ;
}

.header-tab>div:nth-child(3)>div:nth-child(1)>div{
    width: 270px;
}

.contribution-first-table{
    width: 100%;
}

.contribution-first-table>div>div:nth-child(2){
  display: flex;
  /* border: 1px solid lightcyan; */
  margin: 20px;
  margin-left: 50px;
  margin-right: 50px;

  /* background-color: ; */
}

.contribution-first-table>div>div:nth-child(2)>div:nth-child(1){
   width: 5%;
}

.contribution-first-table>div>div:nth-child(2)>div:nth-child(1)>div{
    width: 100px;
    font-size: 15px;
    font-weight: 900;
    padding: 1.25rem 0.5rem 0.75rem;
    text-align: center;
    background: #f6f6f7;
    justify-content: space-between;
    left: 0;
    /* position: sticky; */
    align-items: center;
    border-radius: 3px;
    color: #6c757d;
    display: flex;
    flex-direction: row;
    margin-bottom: 0.25rem;

}

.contribution-first-table>div>div:nth-child(2)>div:nth-child(1)>div:nth-child(2n){
    background: aliceblue;
}


.contribution-first-table>div>div:nth-child(3)>div:nth-child(1)>div:nth-child(2n){
    background: #f6f6f7;
}

.empty-box{
    background: none !important;
}

.contribution-first-table>div:nth-child(2)>div:nth-child(2)>div:nth-child(1)>div{
    background: aliceblue;
}

.contribution-first-table>div:nth-child(2)>div:nth-child(2)>div:nth-child(1)>div:nth-child(2n){
    background: #f6f6f7;
}

.contribution-first-table>div:nth-child(3)>div:nth-child(2)>div:nth-child(1)>div:nth-child(2n){
    background: aliceblue;
}

.weekly-data>div{
    display: flex;
    margin-left: 50px;
}

.weekly-data>div>div{
    font-size: 15px;
    font-weight: 900;
    /* padding: 1.25rem 0.5rem 0.75rem; */
    margin-right: 6px;
    padding: 5px;
    
    height: 54.5px;
    text-align: center;
    background: aliceblue;
    /* justify-content: space-between;
    left: 0; */
    /* position: sticky; */
    align-items: center;
    border-radius: 3px;
    color: #6c757d;
    /* display: flex; */
    /* flex-direction: row; */
    margin-bottom: 0.25rem;

}

.contribution-first-table>div:nth-child(2)>div:nth-child(2)>div:nth-child(2)>div>div{
    background: #f6f6f7;
}

.contribution-first-table>div:nth-child(1)>div:nth-child(2)>div:nth-child(2)>div:nth-child(2n)>div{
    background: #f6f6f7;
}

.contribution-first-table>div:nth-child(2)>div:nth-child(2)>div:nth-child(2)>div:nth-child(2n)>div{
    background: aliceblue;
}

.contribution-first-table>div:nth-child(3)>div:nth-child(2)>div:nth-child(2)>div:nth-child(2n)>div{
    background: #f6f6f7;
}

.weekly-data{
    width: 100%;
    overflow-x:auto ;
    overflow-y: hidden;
   
 }

 .weekly-data::-webkit-scrollbar {
    width: 0; 
  }
  
  .weekly-data::-webkit-scrollbar-thumb {
    background: none; 
  }

 .calender-card{
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    
 }

 .calender-card:hover{
    transform: scaleX(1.2);
    transform: scaleY(1.2);
    box-shadow: 0px 0px 4px #d2d2e4;
 }


 .calender-card>div:nth-child(1){
    font-weight:1000;
    color: black;
    width: 100px;
    z-index: 99;
    cursor: pointer;
 }

 .calender-card>div:nth-child(2){
    font-weight:500;
    font-size: 12px;

 }

 .date-ranger{
    /* text-align: end; */
    display: flex;
    justify-content: space-between;
    margin-right: 3rem;
    margin-left: 3rem;
    /* box-shadow: 0px 0px 5px #dbdbe5; */
    border-bottom: 1px solid lightgray;
    padding-bottom: 10px;
 }


 .date-ranger>div:nth-child(1){
    font-size: 1.5rem;
    font-weight: 600;
 }


 .contribution-first-table>div{
    box-shadow: 0px 0px 10px #dbdbe5;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 30px 0px;
 }

 .contribution-first-table>div:nth-child(1){
    margin-top: 0px !important;
 }

 .contribution-first-table>div:last-child{
    margin-bottom:0px !important;
    
 }

 .weeklystat{
    font-size: 11px !important;
    color: #6c757d !important;
 }



 .monthly-stats{
    width: 100% !important;
    overflow-x: scroll;
    margin-left: 30px;
    display: flex;
 }

 .monthly-stats::-webkit-scrollbar {
    width: 0; 
  }
  
  .monthly-stats::-webkit-scrollbar-thumb {
    background: none; 
  }


 .monthly-stats>div{
    display: flex !important;
    flex-direction: column;
    /* max-width: 600px; */
    margin-right: 30px;
    margin-left: 30px;
 }

 .monthly-stats>div>div{
    display: flex !important;
    background: none !important;
    /* flex-direction: column; */
 }

 .monthly-stats>div>div>div{
    font-size: 15px;
    font-weight: 900;
    /* padding: 1.25rem 0.5rem 0.75rem; */
    margin-right: 6px;
    padding: 5px;
    
    height: 54.5px;
    text-align: center;
    background: aliceblue;
    /* justify-content: space-between;
    left: 0; */
    /* position: sticky; */
    align-items: center;
    border-radius: 3px;
    color: #6c757d;
    /* display: flex; */
    /* flex-direction: row; */
    margin-bottom: 0.25rem;
 }

 .monthly-stats>div>div:nth-child(2n)>div{
    background: #f6f6f7;
 }

 .weekly-data>div:nth-child(2n)>div{
    background-color:#f6f6f7 ;
 }



 .weeklystat{
    /* background: #e0edff !important; */
 }

 .table-map-state .ant-table-thead>tr>th{
    background-color: #6096B4;
    color: white ;
 }

 .table-map-state .ant-table-cell-fix-left{
    background-color: aliceblue;

    font-weight: 700;
 }


 .ant-table-scroll .ant-table-body {
    overflow: hidden;
  }


  .ant-table-body td{
    font-size: 12px ;
  }`, "",{"version":3,"sources":["webpack://./src/components/Contribution/contribution.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;IAClC,oCAAoC;IACpC,+BAA+B;IAC/B,mBAAmB;;AAEvB;;AAEA;CACC,kCAAkC;CAClC,iBAAiB;CACjB,iBAAiB;CACjB,iCAAiC;AAClC;;;;AAIA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;;EAElB,wBAAwB;AAC1B;;AAEA;GACG,SAAS;AACZ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,OAAO;IACP,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;AAE1B;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,YAAY;;IAEZ,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB;cACU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;;AAE1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;;CAErB;;CAEA;IACG,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;CAED;IACG,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;;CAElB;;CAEA;IACG,sBAAsB;IACtB,sBAAsB;IACtB,+BAA+B;CAClC;;;CAGA;IACG,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,eAAe;CAClB;;CAEA;IACG,eAAe;IACf,eAAe;;CAElB;;CAEA;IACG,qBAAqB;IACrB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,qCAAqC;IACrC,kCAAkC;IAClC,oBAAoB;CACvB;;;CAGA;IACG,iBAAiB;IACjB,gBAAgB;CACnB;;;CAGA;IACG,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;CACpB;;CAEA;IACG,0BAA0B;CAC7B;;CAEA;IACG,4BAA4B;;CAE/B;;CAEA;IACG,0BAA0B;IAC1B,yBAAyB;CAC5B;;;;CAIA;IACG,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;CAChB;;CAEA;IACG,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;;CAGD;IACG,wBAAwB;IACxB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;CACpB;;CAEA;IACG,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;CAC/B;;CAEA;IACG,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,YAAY;;IAEZ,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB;cACU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;CACzB;;CAEA;IACG,mBAAmB;CACtB;;CAEA;IACG,yBAAyB;CAC5B;;;;CAIA;IACG,oCAAoC;CACvC;;CAEA;IACG,yBAAyB;IACzB,aAAa;CAChB;;CAEA;IACG,2BAA2B;;IAE3B,gBAAgB;CACnB;;;CAGA;IACG,gBAAgB;EAClB;;;EAGA;IACE,gBAAgB;EAClB","sourcesContent":[".header-tab{\n    display: flex;\n    padding: 20px 20px 0px 20px;\n    align-items: start;\n    background-color: white !important;\n    /* border-bottom: 1px solid gray ; */\n    box-shadow: 0px 0px 5px #d2d2e4;\n    margin-bottom: 20px;\n    \n}\n\n.contribution-first-table{\n background-color: white !important;\n margin-top: -20px;\n padding-top:20px ;\n /* margin-top: 10px !important; */\n}\n\n\n\n.header-tab>div:nth-child(2){\n    width: 80%;\n    margin-left: 30px;\n    height: 46px ;\n}\n\n.header-tab>div:nth-child(3)>div:nth-child(1)>div{\n    width: 270px;\n}\n\n.contribution-first-table{\n    width: 100%;\n}\n\n.contribution-first-table>div>div:nth-child(2){\n  display: flex;\n  /* border: 1px solid lightcyan; */\n  margin: 20px;\n  margin-left: 50px;\n  margin-right: 50px;\n\n  /* background-color: ; */\n}\n\n.contribution-first-table>div>div:nth-child(2)>div:nth-child(1){\n   width: 5%;\n}\n\n.contribution-first-table>div>div:nth-child(2)>div:nth-child(1)>div{\n    width: 100px;\n    font-size: 15px;\n    font-weight: 900;\n    padding: 1.25rem 0.5rem 0.75rem;\n    text-align: center;\n    background: #f6f6f7;\n    justify-content: space-between;\n    left: 0;\n    /* position: sticky; */\n    align-items: center;\n    border-radius: 3px;\n    color: #6c757d;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 0.25rem;\n\n}\n\n.contribution-first-table>div>div:nth-child(2)>div:nth-child(1)>div:nth-child(2n){\n    background: aliceblue;\n}\n\n\n.contribution-first-table>div>div:nth-child(3)>div:nth-child(1)>div:nth-child(2n){\n    background: #f6f6f7;\n}\n\n.empty-box{\n    background: none !important;\n}\n\n.contribution-first-table>div:nth-child(2)>div:nth-child(2)>div:nth-child(1)>div{\n    background: aliceblue;\n}\n\n.contribution-first-table>div:nth-child(2)>div:nth-child(2)>div:nth-child(1)>div:nth-child(2n){\n    background: #f6f6f7;\n}\n\n.contribution-first-table>div:nth-child(3)>div:nth-child(2)>div:nth-child(1)>div:nth-child(2n){\n    background: aliceblue;\n}\n\n.weekly-data>div{\n    display: flex;\n    margin-left: 50px;\n}\n\n.weekly-data>div>div{\n    font-size: 15px;\n    font-weight: 900;\n    /* padding: 1.25rem 0.5rem 0.75rem; */\n    margin-right: 6px;\n    padding: 5px;\n    \n    height: 54.5px;\n    text-align: center;\n    background: aliceblue;\n    /* justify-content: space-between;\n    left: 0; */\n    /* position: sticky; */\n    align-items: center;\n    border-radius: 3px;\n    color: #6c757d;\n    /* display: flex; */\n    /* flex-direction: row; */\n    margin-bottom: 0.25rem;\n\n}\n\n.contribution-first-table>div:nth-child(2)>div:nth-child(2)>div:nth-child(2)>div>div{\n    background: #f6f6f7;\n}\n\n.contribution-first-table>div:nth-child(1)>div:nth-child(2)>div:nth-child(2)>div:nth-child(2n)>div{\n    background: #f6f6f7;\n}\n\n.contribution-first-table>div:nth-child(2)>div:nth-child(2)>div:nth-child(2)>div:nth-child(2n)>div{\n    background: aliceblue;\n}\n\n.contribution-first-table>div:nth-child(3)>div:nth-child(2)>div:nth-child(2)>div:nth-child(2n)>div{\n    background: #f6f6f7;\n}\n\n.weekly-data{\n    width: 100%;\n    overflow-x:auto ;\n    overflow-y: hidden;\n   \n }\n\n .weekly-data::-webkit-scrollbar {\n    width: 0; \n  }\n  \n  .weekly-data::-webkit-scrollbar-thumb {\n    background: none; \n  }\n\n .calender-card{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    cursor: pointer;\n    \n }\n\n .calender-card:hover{\n    transform: scaleX(1.2);\n    transform: scaleY(1.2);\n    box-shadow: 0px 0px 4px #d2d2e4;\n }\n\n\n .calender-card>div:nth-child(1){\n    font-weight:1000;\n    color: black;\n    width: 100px;\n    z-index: 99;\n    cursor: pointer;\n }\n\n .calender-card>div:nth-child(2){\n    font-weight:500;\n    font-size: 12px;\n\n }\n\n .date-ranger{\n    /* text-align: end; */\n    display: flex;\n    justify-content: space-between;\n    margin-right: 3rem;\n    margin-left: 3rem;\n    /* box-shadow: 0px 0px 5px #dbdbe5; */\n    border-bottom: 1px solid lightgray;\n    padding-bottom: 10px;\n }\n\n\n .date-ranger>div:nth-child(1){\n    font-size: 1.5rem;\n    font-weight: 600;\n }\n\n\n .contribution-first-table>div{\n    box-shadow: 0px 0px 10px #dbdbe5;\n    margin-left: 30px;\n    margin-right: 30px;\n    margin-top: 10px;\n    margin-bottom: 20px;\n    padding: 30px 0px;\n }\n\n .contribution-first-table>div:nth-child(1){\n    margin-top: 0px !important;\n }\n\n .contribution-first-table>div:last-child{\n    margin-bottom:0px !important;\n    \n }\n\n .weeklystat{\n    font-size: 11px !important;\n    color: #6c757d !important;\n }\n\n\n\n .monthly-stats{\n    width: 100% !important;\n    overflow-x: scroll;\n    margin-left: 30px;\n    display: flex;\n }\n\n .monthly-stats::-webkit-scrollbar {\n    width: 0; \n  }\n  \n  .monthly-stats::-webkit-scrollbar-thumb {\n    background: none; \n  }\n\n\n .monthly-stats>div{\n    display: flex !important;\n    flex-direction: column;\n    /* max-width: 600px; */\n    margin-right: 30px;\n    margin-left: 30px;\n }\n\n .monthly-stats>div>div{\n    display: flex !important;\n    background: none !important;\n    /* flex-direction: column; */\n }\n\n .monthly-stats>div>div>div{\n    font-size: 15px;\n    font-weight: 900;\n    /* padding: 1.25rem 0.5rem 0.75rem; */\n    margin-right: 6px;\n    padding: 5px;\n    \n    height: 54.5px;\n    text-align: center;\n    background: aliceblue;\n    /* justify-content: space-between;\n    left: 0; */\n    /* position: sticky; */\n    align-items: center;\n    border-radius: 3px;\n    color: #6c757d;\n    /* display: flex; */\n    /* flex-direction: row; */\n    margin-bottom: 0.25rem;\n }\n\n .monthly-stats>div>div:nth-child(2n)>div{\n    background: #f6f6f7;\n }\n\n .weekly-data>div:nth-child(2n)>div{\n    background-color:#f6f6f7 ;\n }\n\n\n\n .weeklystat{\n    /* background: #e0edff !important; */\n }\n\n .table-map-state .ant-table-thead>tr>th{\n    background-color: #6096B4;\n    color: white ;\n }\n\n .table-map-state .ant-table-cell-fix-left{\n    background-color: aliceblue;\n\n    font-weight: 700;\n }\n\n\n .ant-table-scroll .ant-table-body {\n    overflow: hidden;\n  }\n\n\n  .ant-table-body td{\n    font-size: 12px ;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
